<!--
================================================
Vue pour gérer les tags
================================================
http://localhost:8080/fr/samsonite/samsonite-workspace/tags
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div slot="AppContent">
            <!-- Modale tag ----------------------------------------------->
          <modal-tag-management-comp></modal-tag-management-comp>
            <!-- Modale delete project ----------------------------------------------->
<!--            <modal-delete-project-comp></modal-delete-project-comp>--> <!-- @todo réactiver dans https://gitlab.com/ousmane1/kronocloud/-/issues/764-->


            <!-- Entête de la page ----------------------------------------------->
            <div class="columns">
                <div class="column">

                    <!-- titre de la page ----------------------------------------------->
                    <div class="has-text-left appTitle is-hidden-mobile">
                        <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'tag']" />{{$t('Tags')}}</h3>
                        <p class="appSubTitle">{{$t('LesTagsPermettentDeConnaitreLeTempsPasséSurDesTachesIdentiques')}}
                          <br>
                          <small>{{$t('ExemplePourSuivreUneAideDuTypeCIR')}}
                          </small>
                        </p>
                    </div>
                </div>

                <div class="column is-narrow">
                <!-- Bouton new tag ----------------------------------------------->
                    <a v-on:click="createTag()"
                       v-on:keyup.enter="createTag()"
                       v-bind:class="{'is-loading':newTagIsSubmiting}"
                       v-bind:disabled="newTagIsSubmiting" tabindex="0"
                       class="call2ActionBtn button is-primary " id="submitNewTag" >
                        <font-awesome-icon :icon="['fas', 'plus-circle']" class="icon" />
                        <span>{{$t("NouveauTag")}}</span>
                    </a>
                </div>

            </div>

            <!-- List des tags ----------------------------------------------->
          <tag-list-comp></tag-list-comp>

        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    // import Component from '@/components/Component.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    // import ModalDeleteProjectComp from "../components/ModalDeleteProjectComp";  <!-- @todo réactiver dans https://gitlab.com/ousmane1/kronocloud/-/issues/764-->
    import TagListComp from "@/components/Tags/TagListComp";
    import ModalTagManagementComp from "@/components/Tags/ModalTagManagementComp";

    export default {
        name: 'TagsView',
        data: function () {
            return {
                // locale : this.$route.params.locale

                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                componentIsReady : false, // indique quand le composant est prêt à être afficher

                newTagIsSubmiting: false, // true si form création tag en cours de soumission
                // =================================================================
            }
        },
      components: {
        ModalTagManagementComp,
        TagListComp,
        // ModalDeleteProjectComp,  <!-- @todo réactiver dans https://gitlab.com/ousmane1/kronocloud/-/issues/764-->
        AppLayoutComp, SpinnerLoaderComp, TagListComp
        },

        mixins: [VueMetaMixin, SentryMixin, InterceptorMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleTagsView"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {
            /**
             *  Ouvre la modal de création d'un tag
             */
            createTag: function () {
                this.$root.$emit('show_modal_tag_management','creation')
            },

        },
        created: function () {
        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    /*@import "../assets/css/globalVar.scss";*/


</style>
